import { render, staticRenderFns } from "./SlideMaterial.vue?vue&type=template&id=df94f2e6&scoped=true&"
import script from "./SlideMaterial.vue?vue&type=script&lang=js&"
export * from "./SlideMaterial.vue?vue&type=script&lang=js&"
import style0 from "./SlideMaterial.vue?vue&type=style&index=0&id=df94f2e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df94f2e6",
  null
  
)

export default component.exports